import { render } from "./ChatBotMotdDialog.vue?vue&type=template&id=0e95c1bd&scoped=true"
import script from "./ChatBotMotdDialog.vue?vue&type=script&lang=js"
export * from "./ChatBotMotdDialog.vue?vue&type=script&lang=js"

import "./ChatBotMotdDialog.vue?vue&type=style&index=0&id=0e95c1bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e95c1bd"]])

export default __exports__